import { useState } from 'react';
import SlackChannelReviewLevels from './SlackChannelReviewLevels';
import SlackChannelWorkerSources from './SlackChannelWorkerSources';
import SlackChannelTierStatuses from './SlackChannelTierStatuses';
import SlackChannelTags from './SlackChannelTags';
import SlackChannelRequireAllTags from './SlackChannelRequireAllTags';
import SlackChannelCountries from './SlackChannelCountries';
import { SlackInviteTaskerModal } from 'react-scale/corp/views/scalers/SlackChannelsPage';
import { Button } from 'react-scale/components/design-system';
import SlackChannelCommunities from './SlackChannelCommunities';
import { ISlackChannelProps } from './SlackChannel';

const SlackChannelOptions = (props: ISlackChannelProps) => {
  const [inviteModalOpen, setInviteModalOpen] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const { channel, isAdd, isRemove } = props;
  const channelName: string = (channel && channel.name) || '';
  const channelId: string = (channel && channel.channelId) || '';

  return (
    <>
      <div className="item-options-container">
        <SlackChannelCommunities {...props} />
        <SlackChannelCountries {...props} />
        <SlackChannelReviewLevels {...props} />
        <SlackChannelWorkerSources {...props} />
        <SlackChannelTierStatuses {...props} />
        <SlackChannelTags {...props} />
        <SlackChannelRequireAllTags {...props} />
        {!props.disableInviteTaskers && props.isEditable && !isAdd && !isRemove && channelId && (
          <>
            <Button onClick={() => setInviteModalOpen(true)} type="secondary" disabled={loading}>
              + Invite Taskers
            </Button>
            <SlackInviteTaskerModal
              isOpen={inviteModalOpen}
              channelName={channelName}
              channelId={channelId}
              onInvitePre={() => {
                setLoading(true);
                setInviteModalOpen(false);
              }}
              onInvitePost={(_: any) => {
                setLoading(false);
              }}
              onClose={() => setInviteModalOpen(false)}
              isExpert={channel.isExpert}
            />
          </>
        )}
      </div>
      <style>{`
        .item-options-container {
          display: flex;
          flex-direction: column;
          padding-top: 10px;
        }

        .item-option-container {
          display: flex;
          flex-direction: row;
          align-items: center;
          padding: 10px 0px 12px 32px;
        }

        label {
          color: var(--color-RemoGray75);
          font-size: 14px;
          width: 120px;
          white-space: nowrap;
        }
      `}</style>
    </>
  );
};

export default SlackChannelOptions;
